import { useTheme } from '@emotion/react';
import { Grid, IconButton, Typography, useMediaQuery } from '@mui/material';
import { Stack } from '@mui/system';
import { Layout } from 'antd';
import { ReactComponent as Notification } from 'assets/icons/sidebarlocation.svg';
import { ReactComponent as UserGroup } from 'assets/svg/3 User.svg';
import { ReactComponent as Category } from 'assets/svg/Category.svg';
import { ReactComponent as Paper } from 'assets/svg/Paper.svg';
import { PropertyContext } from 'component/PropertyContext/PropertyContext';
import { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import AccountMenu from './AccountMenu/AccountMenu';
const { Footer } = Layout;
export const Footerelements = ({ buyerCheckIn }) => {
  const history = useHistory();
  const InsightIcon = () => {
    return (
      <svg
        width="42"
        height="42"
        viewBox="0 0 42 42"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M26.6376 12.1709C26.6376 10.4844 28.0081 9.11719 29.6987 9.11719C31.3892 9.11719 32.7597 10.4844 32.7597 12.1709C32.7597 13.8575 31.3892 15.2247 29.6987 15.2247C28.0081 15.2247 26.6376 13.8575 26.6376 12.1709ZM31.0415 12.171C31.0415 11.4311 30.4403 10.8314 29.6987 10.8314C28.9571 10.8314 28.3559 11.4311 28.3559 12.171C28.3559 12.9108 28.9571 13.5105 29.6987 13.5105C30.4403 13.5105 31.0415 12.9108 31.0415 12.171ZM25.1086 18.0392C25.3992 17.665 25.9388 17.5967 26.3139 17.8866C26.6549 18.1502 26.7425 18.6191 26.5372 18.9833L26.4668 19.0891L23.1116 23.4092C22.8461 23.751 22.3733 23.8373 22.0078 23.6295L21.9017 23.5583L18.6727 21.0281L15.7737 24.7877C15.5106 25.1287 15.0409 25.2177 14.6752 25.0142L14.5689 24.9443C14.227 24.6819 14.1378 24.2133 14.3418 23.8484L14.4119 23.7423L17.8405 19.2967C18.1054 18.9532 18.5795 18.8658 18.9458 19.074L19.0522 19.1454L22.2822 21.6772L25.1086 18.0392ZM24.749 10.938C24.749 10.4646 24.3644 10.0809 23.8899 10.0809H15.5646L15.2963 10.0854C11.5701 10.2103 9.11686 12.9404 9.11686 16.8167V26.0531L9.12097 26.3289C9.23582 30.1614 11.7494 32.7785 15.5646 32.7785H25.4207L25.6891 32.774C29.4167 32.6495 31.8685 29.9276 31.8685 26.0531V18.0092L31.8606 17.8929C31.8038 17.4745 31.4443 17.1521 31.0094 17.1521C30.5349 17.1521 30.1502 17.5358 30.1502 18.0092V26.0531L30.1455 26.3192C30.0417 29.2139 28.2351 31.0643 25.4207 31.0643H15.5646L15.3094 31.0593C12.5345 30.9488 10.8351 29.0273 10.8351 26.0531V16.8167L10.8399 16.5504C10.9438 13.6527 12.7527 11.7951 15.5646 11.7951H23.8899L24.0065 11.7873C24.4258 11.7305 24.749 11.3719 24.749 10.938Z"
          fill="#112347"
        />
      </svg>
    );
  };

  const [menuOpen, setMenuOpen] = useState(false);

  const handleMenuToggle = (event) => {
    setMenuOpen((prev) => !prev);
  };
  const { isScrolling } = useContext(PropertyContext);
  const currentPage = window.location.pathname;
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Footer
      style={{
        // height: "85px",
        height: 'auto',
        position: 'fixed',
        bottom: '0px',
        width: '100%',
        padding: '0px',
        zIndex: 9999,
        display:
          (currentPage.includes('/market') &&
            isScrolling &&
            matchessm &&
            'none') ||
          (currentPage.includes('/dashboard') &&
            isScrolling &&
            matchessm &&
            'none'),
      }}
    >
      <Grid container sx={{ display: 'flex', flexDirection: 'column' }}>
        {menuOpen && <AccountMenu footer={true} />}
        <Grid item>
          <Stack
            direction={'row'}
            justifyContent={buyerCheckIn ? 'center' : 'space-between'}
            alignItems={'center'}
            sx={{ padding: '0px 0px', height: '100%', width: '100%' }}
          >
            <Stack
              sx={{ display: buyerCheckIn && 'none', width: '20%' }}
              alignItems={'center'}
              onClick={() => history.push('/tasks')}
              style={{ cursor: 'pointer' }}
            >
              <Typography className="bottomicon">
                <Paper width={28} height={28} className="myclass" />
              </Typography>

              <Typography
                sx={{
                  fontFamily: 'poppins',
                  fontSize: '10px',
                  color: '#9A9A9F',
                  lineHeight: '14px',
                }}
              >
                Tasks
              </Typography>
            </Stack>
            <Stack
              sx={{ display: buyerCheckIn && 'none', width: '20%' }}
              alignItems={'center'}
              onClick={() => history.push('/People')}
              style={{ cursor: 'pointer' }}
            >
              <Typography className="bottomicon">
                <UserGroup width={28} height={28} />
              </Typography>
              <Typography
                sx={{
                  fontFamily: 'poppins',
                  fontSize: '10px',
                  color: '#9A9A9F',
                  lineHeight: '14px',
                }}
              >
                Contacts
              </Typography>
            </Stack>
            <Stack
              sx={{ display: buyerCheckIn && 'none', width: '20%' }}
              alignItems={'center'}
              component={IconButton}
              onClick={() => history.push('/dashboard')}
              style={{ cursor: 'pointer' }}
            >
              <Typography className="bottomicon">
                <Category width={28} height={28} className="home" />
              </Typography>
              <Typography
                sx={{
                  fontFamily: 'poppins',
                  fontSize: '10px',
                  color: '#9A9A9F',
                  lineHeight: '14px',
                }}
              >
                Home
              </Typography>
            </Stack>

            <Stack
              sx={{ display: buyerCheckIn && 'none', width: '20%' }}
              alignItems={'center'}
              onClick={() => history.push('/insights')}
              style={{ cursor: 'pointer' }}
            >
              <Typography className="bottomicon">
                {/* <Message width={28} height={28} /> */}
                <InsightIcon />
              </Typography>
              <Typography
                sx={{
                  fontFamily: 'poppins',
                  fontSize: '10px',
                  color: '#9A9A9F',
                  lineHeight: '14px',
                }}
              >
                Insights
              </Typography>
            </Stack>
            <Stack
              sx={{ display: buyerCheckIn && 'none', width: '20%' }}
              alignItems={'center'}
              onClick={() => history.push('/landingpage')}
              style={{ cursor: 'pointer' }}
            >
              <Typography className="bottomicon">
                <Notification width={28} height={28} />
              </Typography>
              <Typography
                sx={{
                  fontFamily: 'poppins',
                  fontSize: '10px',
                  color: '#9A9A9F',
                  lineHeight: '14px',
                }}
              >
                Marketplace
              </Typography>
            </Stack>
            {/* <Stack alignItems={"center"} onClick={handleMenuToggle} style={{ cursor: 'pointer' }}>
        <Typography className="bottomicon">
          <Avatar
            alt="Remy Sharp"
            src={UserImg}
            height={"36px"}
            width={"36px"}
          />
        </Typography>
        <Typography
          sx={{
            fontFamily: "poppins",
            fontSize: "10px",
            color: "#9A9A9F",
            lineHeight: "14px",
          }}
        >
          Account
        </Typography>
        </Stack> */}
          </Stack>
        </Grid>
      </Grid>
    </Footer>
  );
};
